// ** Third Party Components
import styled, { css } from "styled-components";

export const StyledSvgIconContainer = styled.div`
	display: flex;
	position: relative;
	top: 1px;
	${({ customMargin }) =>
		customMargin &&
		css`
			margin: ${customMargin};
		`}

	svg {
		display: inline-block;
		vertical-align: middle;
	}
`;
const TrashIcon = ({ customMargin, height }) => {
	return (
		<StyledSvgIconContainer customMargin={customMargin}>
			<svg
				xmlns="http://www.w3.org/2000/svg"
				viewBox="0 0 448 512"
				height={height}
			>
				{/*<!-- Font Awesome Pro 5.15.4 by @fontawesome - https://fontawesome.com License - https://fontawesome.com/license (Commercial License) -->*/}
				<path d="M432 80h-82.4l-34-56.7A48 48 0 0 0 274.4 0H173.6a48 48 0 0 0-41.2 23.3L98.4 80H16A16 16 0 0 0 0 96v16a16 16 0 0 0 16 16h16l21.2 339a48 48 0 0 0 47.9 45h245.8a48 48 0 0 0 47.9-45L416 128h16a16 16 0 0 0 16-16V96a16 16 0 0 0-16-16zM173.6 48h100.8l19.2 32H154.4zm173.3 416H101.11l-21-336h287.8z" />
			</svg>
		</StyledSvgIconContainer>
	);
};

export default TrashIcon;
